import { create } from 'zustand';

interface ResubmissionRecheckState {
    /** Per lead, how often a fresh due-resubmission check was requested - a new value starts a new check. */
    requests: Record<string, number>;
}

export const useResubmissionRecheckStore = create<ResubmissionRecheckState>()(() => ({
    requests: {},
}));

/** Asks the lead details page of `leadId` to check again whether its resubmission is due (e.g. after a bell click). */
export const requestResubmissionRecheck = (leadId: string) => {
    useResubmissionRecheckStore.setState((state) => ({
        requests: { ...state.requests, [leadId]: (state.requests[leadId] ?? 0) + 1 },
    }));
};
